import type { ComponentProps } from "react";
import styles from "./RingRadio.module.css";

type RingRadioProps = Omit<ComponentProps<"input">, "type">;

/** A radio drawn as a ring with a dot. The native radio sits over the ring, so clicks and labels work as usual. */
export function RingRadio({ className, ...inputProps }: RingRadioProps) {
  const classes = [styles.ring, className].filter(Boolean).join(" ");

  return (
    <span className={classes}>
      <input {...inputProps} type="radio" className={styles.input} />
      <span className={styles.circle} aria-hidden="true" />
    </span>
  );
}
